import { ChangeEvent, useEffect } from "react";
import { formatString } from "@format-string/core";
import { Box, MenuItem } from "@mui/material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { IValuesFilterBordero } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import { valuesDefaultFilterBordero } from "src/Contexts/Lancamentos/Contrato/valuesDefaultInputsContratos/ValueDefaultInputContratos";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { AppTextField } from "src/Pages/components";
import { AutoCompleteCorretorGeneric } from "src/Pages/components/AutoCompleted/AutoCompleteCorretor";
import { AutoCompleteOperadoraFilter } from "src/Pages/components/AutoCompleted/Filters/AutoCompleteOperadora";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";
import { ModalFilterCore } from "src/Pages/components/ModalFilterCore/Index";
import { apenasNumeros } from "src/shared/Utils/FormatMoney";

import { useHttpTableBordero } from "../../table/Hooks/useHttpTableBordero";
import { AutoCompleteAdministradoras } from "src/Pages/components/AutoCompleted/AutoCompleteAdministradoras";
import { useParams } from "react-router";

interface IFilterSidebarBordero {
  clearFilters?: () => void;
}

export const FilterSidebarBordero = ({ clearFilters }: IFilterSidebarBordero) => {
  const { handleGet } = useHttpTableBordero();
  const { id } = useParams();

  const { valuesFilterBordero, setValuesFilterBordero, orderTable, } = useContextContrato();
  const {
    valueAutoCompOperadoraFilter,
    setValueAutoCompOperadoraFilter,
    valueAutoCompProdutorActive,
    valueAutoCompAdministradora,
    setValueAutoCompProdutorActive,
  } = UseAutoCompletedAll();

  const handleChange =
    (prop: keyof IValuesFilterBordero, option?: "apenasNumero" | "CPF_CNPJ") =>
      (event: ChangeEvent<HTMLInputElement>) => {
        if (option === "apenasNumero") {
          if (event.target.value.length <= 5) {
            setValuesFilterBordero({
              ...valuesFilterBordero,
              [prop]: apenasNumeros(event.target.value),
            });
          }
        } else if (option === "CPF_CNPJ") {
          setValuesFilterBordero({
            ...valuesFilterBordero,
            [prop]: formatString({
              type: "cpfOurCnpj",
              value: event.target.value,
            }),
          });
        } else {
          setValuesFilterBordero({
            ...valuesFilterBordero,
            [prop]: event.target.value,
          });
        }
      };

  const ClearFilter = async () => {
    setValuesFilterBordero(valuesDefaultFilterBordero);
    setValueAutoCompOperadoraFilter({ id: "", label: "" });
    setValueAutoCompProdutorActive({ id: "", label: "" });

    await handleGet({
      id_contrato: id || undefined,
      orderTable: orderTable,
      isDeleted: id ? "ALL" : "FALSE",
    });
  };

  useEffect(() => {
    setValuesFilterBordero({
      ...valuesFilterBordero,
      endDateSignature: valuesFilterBordero.startDateSignature,
    });
  }, [valuesFilterBordero.startDateSignature]);

  useEffect(() => {
    setValuesFilterBordero({
      ...valuesFilterBordero,
      endDateReceipt: valuesFilterBordero.startDateReceipt,
    });
  }, [valuesFilterBordero.startDateReceipt]);

  useEffect(() => {
    setValuesFilterBordero({
      ...valuesFilterBordero,
      endDueDate: valuesFilterBordero.startDueDate,
    });
  }, [valuesFilterBordero.startDueDate]);

  useEffect(() => {
    setValuesFilterBordero({
      ...valuesFilterBordero,
      endDateEmission: valuesFilterBordero.startDateEmission,
    });
  }, [valuesFilterBordero.startDateEmission]);

  const FilterSearch = async () => {
    await handleGet({
      id_contrato: id,
      codProposta: valuesFilterBordero.cod_proposta,
      orderTable,
      codeOperadora: valueAutoCompOperadoraFilter.id,
      codeCorretor: valueAutoCompProdutorActive.id,
      codeAdministradora: valueAutoCompAdministradora.id,

      startDateSignature: valuesFilterBordero.startDateSignature,
      endDateSignature: valuesFilterBordero.endDateSignature,

      startDateEmission: valuesFilterBordero.startDateEmission,
      endDateEmission: valuesFilterBordero.endDateEmission,

      endDueDate: valuesFilterBordero.endDueDate,
      startDueDate: valuesFilterBordero.startDueDate,

      startDateReceipt: valuesFilterBordero.startDateReceipt,
      endDateReceipt: valuesFilterBordero.endDateReceipt,

      installmentNumber: valuesFilterBordero.installmentNumber,
      installmentReceipt: valuesFilterBordero.installmentReceipt,

      isInstallmentBroker: valuesFilterBordero.isInstallmentBroker,
      isInstallmentSupervisor: valuesFilterBordero.isInstallmentSupervisor,
      isInstallmentManager: valuesFilterBordero.isInstallmentManager,

      isVitalicioCorretora: valuesFilterBordero.isVitalicioCorretora,
      isVitalicioCorretor: valuesFilterBordero.isVitalicioCorretor,
      isVitalicioSupervisor: valuesFilterBordero.isVitalicioSupervisor,
      isVitalicioGerente: valuesFilterBordero.isVitalicioGerente,
      isDeleted: id ? "ALL" : valuesFilterBordero.isDeleted,

      installmentNumberOperator: valuesFilterBordero.installmentNumberOperator,

      client: {
        nameOrRazao: valuesFilterBordero.nameOrRazao,
        cpfCnpj: valuesFilterBordero.cpfCnpj,
      },
    });
  };


  return (
    <ModalFilterCore FilterClear={async () => {
      clearFilters?.();
      ClearFilter();
    }} FilterSearch={FilterSearch}>
      {!id && (
        <>
          <DividerCore
            sxStyle={{ marginBottom: "14px", marginTop: "0" }}
            title="Proposta"
          />
          <Box
            id="container cliente"
            sx={{
              "& > .MuiAutocomplete-root, & > .MuiTextField-root": {
                flexWrap: "wrap",
                display: "flex",
                marginBottom: "1rem",
              },
            }}
          >
            <AppTextField
              label="Código proposta"
              sxStyle={{ opacity: "", pointerEvents: "auto", width: "100%" }}
              value={valuesFilterBordero.cod_proposta}
              variant="outlined"
              onChange={handleChange("cod_proposta")}
            />
            <AppTextField
              label="Titular/Razão"
              sxStyle={{ opacity: "", pointerEvents: "auto", width: "100%" }}
              value={valuesFilterBordero.nameOrRazao}
              variant="outlined"
              onChange={handleChange("nameOrRazao")}
            />
            <AppTextField
              label="CPF/CNPJ"
              sxStyle={{ opacity: "", pointerEvents: "auto", width: "100%" }}
              value={valuesFilterBordero.cpfCnpj}
              variant="outlined"
              onChange={handleChange("cpfCnpj", "CPF_CNPJ")}
            />
          </Box>
        </>
      )}

      <Box
        id="container propostas"
        sx={{
          "& > .MuiAutocomplete-root, & > .MuiTextField-root": {
            flexWrap: "wrap",
            display: "flex",
            marginBottom: "1rem",
          },
        }}
      >
        <DividerCore sxStyle={{ marginBottom: "12px" }} title="Parcelas" />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
            alignItems: "center",
          }}
        >
          <AppTextField
            label="Data de recebimento"
            sxStyle={{ opacity: "", pointerEvents: "auto", width: "45%" }}
            type="date"
            value={valuesFilterBordero.startDateReceipt}
            variant="outlined"
            onChange={handleChange("startDateReceipt")}
          />
          até
          <AppTextField
            label="Data recebimento"
            sxStyle={{ opacity: "", pointerEvents: "auto", width: "45%" }}
            type="date"
            value={valuesFilterBordero.endDateReceipt}
            variant="outlined"
            onChange={handleChange("endDateReceipt")}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
            alignItems: "center",
          }}
        >
          <AppTextField
            label="Data de vencimento"
            sxStyle={{ opacity: "", pointerEvents: "auto", width: "45%" }}
            type="date"
            value={valuesFilterBordero.startDueDate}
            variant="outlined"
            onChange={handleChange("startDueDate")}
          />
          até
          <AppTextField
            label="Data de vencimento"
            sxStyle={{ opacity: "", pointerEvents: "auto", width: "45%" }}
            type="date"
            value={valuesFilterBordero.endDueDate}
            variant="outlined"
            onChange={handleChange("endDueDate")}
          />
        </Box>
        <Box
          id="container cliente"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
            alignItems: "center",
          }}
        >
          <AppTextField
            select
            id="parcelas_recebida"
            label="Parcelas recebidas ?"
            sxStyle={{ width: "100%", opacity: "", pointerEvents: "auto" }}
            value={valuesFilterBordero.installmentReceipt}
            variant="outlined"
            onChange={handleChange("installmentReceipt")}
          >
            <MenuItem value="ALL">Todas</MenuItem>
            <MenuItem value="TRUE">Recebidas</MenuItem>
            <MenuItem value="FALSE">Não recebidas</MenuItem>
          </AppTextField>
        </Box>


        <Box
          id="container parcela"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
            alignItems: "center",
          }}
        >
          <AppTextField
            select
            id="Numero_da_parcela"
            label="Parcela igual a ?"
            sxStyle={{ width: "45%", opacity: "", pointerEvents: "auto" }}
            value={valuesFilterBordero?.installmentNumberOperator}
            variant="outlined"
            onChange={handleChange("installmentNumberOperator")}
          >
            <MenuItem value="ALL">Todas</MenuItem>
            <MenuItem value="EQUAL">Igual</MenuItem>
            <MenuItem value="GREATER">Maior que</MenuItem>
            <MenuItem value="LESS">Menor que</MenuItem>
          </AppTextField>

          <AppTextField
            label="Numero da parcela"
            sxStyle={{ opacity: "", pointerEvents: "auto", width: "45%" }}
            type="number"
            value={valuesFilterBordero.installmentNumber}
            variant="outlined"
            disabled={valuesFilterBordero?.installmentNumberOperator === "ALL"}
            onChange={handleChange("installmentNumber", "apenasNumero")}
          />
        </Box>
        <DividerCore sxStyle={{ marginBottom: "12px" }} title="" />
        <Box
          id="container cliente"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
            alignItems: "center",
          }}
        >
          <AppTextField
            select
            id="Parc_paga_corretor"
            label="Parc. paga corretor ?"
            sxStyle={{ width: "30%", opacity: "", pointerEvents: "auto" }}
            value={valuesFilterBordero?.isInstallmentBroker}
            variant="outlined"
            onChange={handleChange("isInstallmentBroker")}
          >
            <MenuItem value="ALL">Todas</MenuItem>
            <MenuItem value="TRUE">Sim</MenuItem>
            <MenuItem value="FALSE">Não</MenuItem>
          </AppTextField>
          <AppTextField
            select
            id="Parc_paga_supervisor"
            label="Parc. paga supervisor ?"
            sxStyle={{ width: "30%", opacity: "", pointerEvents: "auto" }}
            value={valuesFilterBordero?.isInstallmentSupervisor}
            variant="outlined"
            onChange={handleChange("isInstallmentSupervisor")}
          >
            <MenuItem value="ALL">Todas</MenuItem>
            <MenuItem value="TRUE">Sim</MenuItem>
            <MenuItem value="FALSE">Não</MenuItem>
          </AppTextField>
          <AppTextField
            select
            id="Parc_paga_gerente"
            label="Parc. paga gerente ?"
            sxStyle={{ width: "30%", opacity: "", pointerEvents: "auto" }}
            value={valuesFilterBordero?.isInstallmentManager}
            variant="outlined"
            onChange={handleChange("isInstallmentManager")}
          >
            <MenuItem value="ALL">Todas</MenuItem>
            <MenuItem value="TRUE">Sim</MenuItem>
            <MenuItem value="FALSE">Não</MenuItem>
          </AppTextField>
        </Box>

        <Box
          id="container vitalicio"
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "0.5rem",
            marginBottom: "1rem",
            alignItems: "center",
          }}
        >
          <AppTextField
            select
            id="Vitalicio_corretora"
            label="Vitalício corretora ?"
            sxStyle={{ minWidth: "140px", flex: 1, opacity: "", pointerEvents: "auto" }}
            value={valuesFilterBordero?.isVitalicioCorretora}
            variant="outlined"
            onChange={handleChange("isVitalicioCorretora")}
          >
            <MenuItem value="ALL">Todos</MenuItem>
            <MenuItem value="TRUE">Sim</MenuItem>
            <MenuItem value="FALSE">Não</MenuItem>
          </AppTextField>
          <AppTextField
            select
            id="Vitalicio_corretor"
            label="Vitalício corretor ?"
            sxStyle={{ minWidth: "140px", flex: 1, opacity: "", pointerEvents: "auto" }}
            value={valuesFilterBordero?.isVitalicioCorretor}
            variant="outlined"
            onChange={handleChange("isVitalicioCorretor")}
          >
            <MenuItem value="ALL">Todos</MenuItem>
            <MenuItem value="TRUE">Sim</MenuItem>
            <MenuItem value="FALSE">Não</MenuItem>
          </AppTextField>
          <AppTextField
            select
            id="Vitalicio_supervisor"
            label="Vitalício supervisor ?"
            sxStyle={{ minWidth: "140px", flex: 1, opacity: "", pointerEvents: "auto" }}
            value={valuesFilterBordero?.isVitalicioSupervisor}
            variant="outlined"
            onChange={handleChange("isVitalicioSupervisor")}
          >
            <MenuItem value="ALL">Todos</MenuItem>
            <MenuItem value="TRUE">Sim</MenuItem>
            <MenuItem value="FALSE">Não</MenuItem>
          </AppTextField>
          <AppTextField
            select
            id="Vitalicio_gerente"
            label="Vitalício gerente ?"
            sxStyle={{ minWidth: "140px", flex: 1, opacity: "", pointerEvents: "auto" }}
            value={valuesFilterBordero?.isVitalicioGerente}
            variant="outlined"
            onChange={handleChange("isVitalicioGerente")}
          >
            <MenuItem value="ALL">Todos</MenuItem>
            <MenuItem value="TRUE">Sim</MenuItem>
            <MenuItem value="FALSE">Não</MenuItem>
          </AppTextField>
        </Box>

        <Box
          id="container parcela_deletada"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
            alignItems: "center",
          }}
        >
          <AppTextField
            select
            id="is_deleted"
            label="Contrato deletado ?"
            sxStyle={{ width: "100%", opacity: "", pointerEvents: "auto" }}
            value={valuesFilterBordero.isDeleted}
            variant="outlined"
            onChange={handleChange("isDeleted")}
          >
            <MenuItem value="ALL">Todos</MenuItem>
            <MenuItem value="FALSE">Não</MenuItem>
            <MenuItem value="TRUE">Sim</MenuItem>
          </AppTextField>
        </Box>

        <DividerCore sxStyle={{ marginBottom: "12px" }} title="Outros filtros" />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
            alignItems: "center",
          }}
        >
          <AppTextField
            label="Data assinatura"
            sxStyle={{ opacity: "", pointerEvents: "auto", width: "45%" }}
            type="date"
            value={valuesFilterBordero.startDateSignature}
            variant="outlined"
            onChange={handleChange("startDateSignature")}
          />
          até
          <AppTextField
            label="Data assinatura"
            sxStyle={{ opacity: "", pointerEvents: "auto", width: "45%" }}
            type="date"
            value={valuesFilterBordero.endDateSignature}
            variant="outlined"
            onChange={handleChange("endDateSignature")}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
            alignItems: "center",
          }}
        >
          <AppTextField
            label="Data emissão"
            sxStyle={{ opacity: "", pointerEvents: "auto", width: "45%" }}
            type="date"
            value={valuesFilterBordero.startDateEmission}
            variant="outlined"
            onChange={handleChange("startDateEmission")}
          />
          até
          <AppTextField
            label="Data emissão"
            sxStyle={{ opacity: "", pointerEvents: "auto", width: "45%" }}
            type="date"
            value={valuesFilterBordero.endDateEmission}
            variant="outlined"
            onChange={handleChange("endDateEmission")}
          />
        </Box>

        <AutoCompleteCorretorGeneric
          fullWidth
          label="Corretor"
          variant="outlined"
        />

        <AutoCompleteOperadoraFilter
          fullWidth
          label="Operadora"
          variant="outlined"
        />

        <AutoCompleteAdministradoras
          fullWidth
          label="Administradoras"
          variant="outlined"
        />
      </Box>

    </ModalFilterCore>
  );
};
